

import { FaInstagram, FaFacebook } from 'react-icons/fa';
import "../Home_css/contact.css";
import {Col,Container,Row} from 'react-bootstrap';
// import contactimg from '../../Assets/Website_Images/AboutPage.JPG'
import contactimg from "../../Assets/Dahlia_images/OZ84524.jpg";

const ContactCard = () => {
  return (
    <section id='Contact'>
      <div>
 <Container>
    <div  className="contact-container">
      <div className="content-section">
        {/* Left Section - Content */}
        <div className="left-content">
          <h1 className="contact-title">CONTACT US</h1>

          {/* Textarea Input Field */}
          {/* <textarea className="contact-textarea"/> */}

          <div className="contact-info">
            <div className="info-block">
              <p className="info-phone">Phone</p>
              <p className="info-Number">515.257.6868</p>
              <div className='clearfix'></div>
              <Row>
                {/* <Col className="info-address" lg="7">Address<br/>Urbandale, IA</Col> */}
                
                <Col className="social-icons" lg="5">
                  <p className="social-text">Follow Us</p>
                  <div className="icons">
                  <a href="https://www.instagram.com/dahlia.health/" target="_blank" aria-label="Dahlia" rel="noopener noreferrer">
        <FaInstagram  />
      </a>
      <a href="https://www.facebook.com/profile.php?id=100070129232090" target="_blank" aria-label="Dahlia" rel="noopener noreferrer">
        <FaFacebook  />
      </a>
  
                  </div>
                </Col>
              </Row>
            </div>
            
          </div>

          <div className="social-and-button" >
            <div className="social-icons">
             
            </div>
            <div>
      <a
        href="https://link.dahliahealth.com/widget/booking/gd1QJvU7rEkI6bAqYkCm"
        className="get-started-btn"
      >
        Get Started 
      </a>
    </div>
          </div>
        </div>
      </div>

      {/* Right Section - Image */}
      <div className="image-section">
         <img src={contactimg} alt="Contact" />
      </div>
    </div>
    </Container>
    </div>
    </section>
  );
};

export default ContactCard;